import {
  FETCH_DEPARTMENT_REQUEST,
  FETCH_DEPARTMENT_SUCCESS,
  FETCH_DEPARTMENT_FAILURE,
  ADD_DEPARTMENT_REQUEST,
  ADD_DEPARTMENT_SUCCESS,
  ADD_DEPARTMENT_FAILURE,
  UPDATE_DEPARTMENT_REQUEST,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_FAILURE,
  DELETE_DEPARTMENT_REQUEST,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAILURE,
  DEPARTMENT_FORM_ERROR,
  DEPARTMENT_FORM_SUCCESS,
  SET_DEPARTMENT_EDIT,
  CLEAR_DEPARTMENT_EDIT,
} from '../../../../types/masters/department/department/departmentTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingDepartment: null,
};

const departmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEPARTMENT_REQUEST:
    case ADD_DEPARTMENT_REQUEST:
    case UPDATE_DEPARTMENT_REQUEST:
    case DELETE_DEPARTMENT_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DEPARTMENT_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_DEPARTMENT_SUCCESS:
    case UPDATE_DEPARTMENT_SUCCESS:
    case DELETE_DEPARTMENT_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_DEPARTMENT_FAILURE:
    case ADD_DEPARTMENT_FAILURE:
    case UPDATE_DEPARTMENT_FAILURE:
    case DELETE_DEPARTMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DEPARTMENT_FORM_ERROR:
      return { ...state, loading: false, formError: action.payload };
    case DEPARTMENT_FORM_SUCCESS:
      return { ...state, loading: false, formSuccess: action.payload };
    case SET_DEPARTMENT_EDIT:
      return { ...state, editingDepartment: action.payload };
    case CLEAR_DEPARTMENT_EDIT:
      return { ...state, editingDepartment: null };
    default:
      return state;
  }
};

export default departmentReducer; 